import { observer } from 'mobx-react';
import { useStore } from 'models/utils';
import React, { CSSProperties, useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import AppHeaderScore from './AppHeaderScore';
import HeaderPlayButton from './HeaderPlayButton';
import HeaderScoreScreenButton from './HeaderScoreScreenButton';
import { Routes } from '../constants';

const AppHeader: React.FC = observer((props) => {
  const { currentUser } = useStore();
  const history = useHistory();
  const location = useLocation();

  const goToPlay = useCallback(() => {
    history.push(Routes.play);
  }, [history]);

  const goToScore = useCallback(() => {
    history.push(Routes.score);
  }, [history]);

  const isActivePlayScreen = location.pathname === Routes.play;
  const isActiveScoreScreen = location.pathname === Routes.score;

  return (
    <header style={headerStyle} className="AppHeader">
      <HeaderPlayButton onClick={isActivePlayScreen ? undefined : goToPlay} hidden={isActivePlayScreen} />
      <AppHeaderScore coins={currentUser.coins} />
      <HeaderScoreScreenButton
        onClick={isActiveScoreScreen ? undefined : goToScore}
        hidden={isActiveScoreScreen || !currentUser.isScoreScreenUnlocked}
      />
    </header>
  );
});

const headerStyle: CSSProperties = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  zIndex: 9,
  // backgroundColor: '#CC4B09',
  height: '70px',
  padding: '6px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  margin: '0 auto',
};

export default AppHeader;
